// Onde guardar os arquivos prontos (Scanner PDF e PDF Edit, 0.49/0.50): neste aparelho, no Google Drive ou no OneDrive.
// Celular Android: numa pasta escolhida uma vez. iPhone: "Salvar em Arquivos". Navegador: baixa o arquivo.
import type { DestinoScan } from '../store/types';
import { t } from './i18n';
import { salvarECompartilhar } from './arquivoSalvar';
import { enviarBytes, contaDe, NOME } from './nuvem';
import { semBloqueio } from '../auth/AuthContext';
import { gravarNaPasta } from './scanArquivos';
import { registrarRelatorio } from './relatorios';

export type Salvo = { onde: DestinoScan; em: string; url?: string; pasta?: string };

export const nomeDestino = (g: DestinoScan) => (g === 'aparelho' ? t('neste dispositivo') : NOME[g]);
/** Nome de arquivo sem caracteres que o Windows, o Drive ou o OneDrive recusam. */
export const nomeSeguro = (nome: string, ext: string) => (nome.replace(/[\\/:*?"<>|]+/g, '-').replace(/\s+/g, ' ').trim().slice(0, 120) || 'arquivo') + ext;

/** Guarda os bytes no destino. semPerguntar: não abre janelas (usado em segundo plano). Devolve null se não guardou. */
export async function guardarBytes(nome: string, mime: string, bytes: Uint8Array, onde: DestinoScan, semPerguntar = false): Promise<(Salvo & { msg: string | null }) | null> {
  if (onde !== 'aparelho' && !contaDe(onde)) {
    if (semPerguntar) return null;
    throw new Error(t('Conecte o {nome} em Ajustes › Google Drive e OneDrive.', { nome: NOME[onde] }));
  }
  const em = new Date().toISOString();
  if (onde !== 'aparelho') {
    const r = await enviarBytes(onde, nome, mime, bytes);
    registrarRelatorio({ nome, mime, tamanho: bytes.length, url: r.url });
    return { onde, em, url: r.url, msg: t('Guardado no {nome}.', { nome: NOME[onde] }) };
  }
  const r = await gravarNaPasta(nome, bytes, !semPerguntar, mime);
  if (r) registrarRelatorio({ nome, mime, tamanho: bytes.length, uri: r.uri });
  if (r) return { onde, em, pasta: r.pasta, msg: t('Guardado na pasta "{pasta}" do celular.', { pasta: r.pasta }) };
  if (semPerguntar) return null;
  // iPhone e navegador: a janela de salvar do sistema (no iPhone, "Salvar em Arquivos"; no navegador, baixa)
  await semBloqueio(() => salvarECompartilhar(bytes, nome, mime));
  return { onde, em, msg: null };
}
